export default __webpack_public_path__ + "0f863fc954171b2264c8254b4bae72ab.svg";